var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-table" },
    [
      _c(
        "div",
        { staticClass: "customHeader" },
        [
          _vm.keys
            ? _c("CustomTabelHeader", {
                ref: "customTabelHeaderRef",
                attrs: { keys: _vm.keys, columns: _vm.initColumns },
                on: { change: _vm.handleBanChange },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "myTable",
          staticClass: "element-table-list",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: _vm.border,
            "tooltip-effect": "dark",
            height: "100%",
            "header-cell-style": _vm.headerCellStyle,
            "cell-style": _vm.cellStyle,
            "row-key": _vm.rowKey,
            "show-summary": _vm.showSummary,
            "summary-method": _vm.summaryMethod,
            "default-sort": _vm.defaultSort,
            "row-class-name": _vm.rowClassName,
            "span-method": _vm.spanMethod,
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "cell-mouse-enter": _vm.handleCellMouseEnter,
            "cell-mouse-leave": _vm.handleCellMouseLeave,
            "sort-change": _vm.handleSortChange,
            "select-all": _vm.handleSelectionAllChange,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "empty",
                fn: function () {
                  return [
                    _vm.slotArr.includes("empty")
                      ? [_vm._t("empty")]
                      : _c("div", [
                          _vm._v(_vm._s(_vm.emptyText || "暂无数据")),
                        ]),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _vm.checkbox
            ? _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  "reserve-selection": _vm.reserveSelection,
                  align: "center",
                  selectable: _vm.selectable,
                },
              })
            : _vm._e(),
          _vm.ifIndex
            ? _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: _vm.tableIndexWidth,
                  label: "序号",
                  fixed: _vm.indexLocation,
                },
              })
            : _vm._e(),
          _vm.treeMode
            ? _c("el-table-column", {
                attrs: { width: 155, label: _vm.rowKey, prop: _vm.rowKey },
              })
            : _vm._e(),
          _vm._l(_vm.initColumns, function (item, index) {
            return [
              item.visible === true || item.visible === undefined
                ? [
                    item.type === "slot"
                      ? _c(
                          "el-table-column",
                          _vm._b(
                            {
                              key: index,
                              attrs: {
                                "render-header": _vm.hasHeaderSlot(item)
                                  ? null
                                  : _vm.renderHeade,
                              },
                              scopedSlots: _vm._u(
                                [
                                  item.headerSlot
                                    ? {
                                        key: "header",
                                        fn: function () {
                                          return [
                                            _vm._t(
                                              `${item.prop + "-header"}`,
                                              null,
                                              { row: item }
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      }
                                    : null,
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._t(item.prop, null, {
                                          row: scope.row,
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "el-table-column",
                            item,
                            false
                          )
                        )
                      : item.isPhone
                      ? _c(
                          "el-table-column",
                          _vm._b(
                            {
                              key: index,
                              attrs: { "render-header": _vm.renderHeade },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c("tablePhoneItem", {
                                          attrs: {
                                            "phone-area-code": row.areaCodeKey
                                              ? row[row.areaCodeKey]
                                              : row.phoneAreaCode,
                                            copy: item.copy,
                                            "row-data": {
                                              ...row,
                                              moduleCode: item.moduleCode || "",
                                            },
                                            "set-phone": item.setPhone,
                                            type: item.phoneType,
                                            "phone-authority":
                                              item.phoneAuthority,
                                          },
                                          model: {
                                            value: row[item.prop],
                                            callback: function ($$v) {
                                              _vm.$set(row, item.prop, $$v)
                                            },
                                            expression: "row[item.prop]",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "el-table-column",
                            item,
                            false
                          )
                        )
                      : item.aiData
                      ? _c(
                          "el-table-column",
                          _vm._b(
                            {
                              key: index,
                              attrs: { "render-header": _vm.renderHeade },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "warpIconAi" },
                                          [
                                            item.aiData.show(row) &&
                                            _vm.organConfig.aiAgent
                                              ? _c("img", {
                                                  staticClass: "iconAi",
                                                  attrs: {
                                                    src: require("@/assets/image/aigc/aiIcon.png"),
                                                    alt: "",
                                                    srcset: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleshowAi(
                                                        row,
                                                        item
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _c("span", [
                                              _vm._v(_vm._s(row[item.prop])),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "el-table-column",
                            item,
                            false
                          )
                        )
                      : item.isEmail
                      ? _c(
                          "el-table-column",
                          _vm._b(
                            {
                              key: index,
                              attrs: { "render-header": _vm.renderHeade },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c("tableEmailItem", {
                                          attrs: {
                                            copy: item.copy,
                                            "row-data": row,
                                            "user-key": item.userKey,
                                            "set-email": item.setEmail,
                                            type: item.emailType,
                                            "email-authority":
                                              item.emailAuthority,
                                          },
                                          model: {
                                            value: row[item.prop],
                                            callback: function ($$v) {
                                              _vm.$set(row, item.prop, $$v)
                                            },
                                            expression: "row[item.prop]",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "el-table-column",
                            item,
                            false
                          )
                        )
                      : item.slotFn
                      ? _c(
                          "el-table-column",
                          _vm._b(
                            {
                              key: index,
                              attrs: { "render-header": _vm.renderHeade },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(item.slotFn(row)) + " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "el-table-column",
                            item,
                            false
                          )
                        )
                      : item["show-overflow-tooltip"]
                      ? _c(
                          "el-table-column",
                          _vm._b(
                            {
                              key: index,
                              attrs: { "render-header": _vm.renderHeade },
                            },
                            "el-table-column",
                            item,
                            false
                          )
                        )
                      : _c(
                          "el-table-column",
                          _vm._b(
                            {
                              key: index,
                              attrs: {
                                "render-header": _vm.renderHeade,
                                sortable: item.sortable || false,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("MBaseTableItem", {
                                          attrs: {
                                            item: item,
                                            "render-data": scope.row,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "el-table-column",
                            item,
                            false
                          )
                        ),
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }